/*  Note: Commenting out all code relating to Download All NCDMs as we move forward with topic development.
    That will be refactored to handle downloading all data for a topic, not just NCDM data. */

// Modules
import React, { useContext } from 'react';

// Styles
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

// Utilities
import {
    printNcdm,
    /* Commenting out all code relating to Download All NCDMs  */
    // downloadNcdm,
    // downloadAllTopicNcdms,
} from 'utilities/ncdmUtils';

import TopicConfigContext from 'utilities/topicConfigContext';

// Components
import AboutTheData from './AboutTheData';

export default function OptionsPopup({
    ncdmContent,
    /* Commenting out all code relating to Download All NCDMs  */
    // ncdmSelections,
    // topicNcdms,
}) {
    // State
    const [anchorEl, setAnchorEl] = React.useState(null);

    // Context
    const topicConfigContext = useContext(TopicConfigContext);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlePrint = () => {
        handleClose();
        printNcdm(ncdmContent);
    };

    /* Commenting out all code relating to Download All NCDMs  */
    // const handleDownload = (allData = false) => {
    //     handleClose();
    //     if (!allData) {
    //         downloadNcdm(topicNcdms, ncdmSelections, ncdmContent);
    //     } else {
    //         downloadAllTopicNcdms(topicNcdms);
    //     }
    // };

    return (
        <>
            <div>
                <IconButton
                    aria-controls="basic-menu"
                    aria-haspopup="true"
                    aria-label="options-menu"
                    onClick={handleClick}
                    size="large"
                    sx={{ margin: '0.7rem 0.5rem 0 0' }}
                >
                    <MoreVertIcon></MoreVertIcon>
                </IconButton>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={anchorEl !== null}
                    onClose={handleClose}
                >
                    <MenuItem onClick={handlePrint}>Print</MenuItem>
                    {/* Commenting out all code relating to Download All NCDMs */}
                    {/* {topics[topic].omitNcdmData ? null : (
                <MenuItem onClick={() => handleDownload(true)}>
                    Download all NCDM data (zip)
                </MenuItem>
            )} */}
                    <MenuItem onClick={handleClose}>
                        <AboutTheData
                            aboutText={topicConfigContext.topic.aboutData}
                        />
                    </MenuItem>
                </Menu>
            </div>
        </>
    );
}
